export const ENV_WEB = 0;
export const ENV_ECLIPSE = 1;
export const ENV_VSCODE = 2;


export const IP_ENABLE = 'Enable';
export const IP_DISABLE = 'Disable';

export const CONFIG_NAME_GPIO = 'GPIO';

export const CONFIG_NAME_USART = 'USART';


export const USART_SIGNAL_TX = 'TX';
export const USART_SIGNAL_RX = 'RX';
export const USART_SIGNAL_CTS = 'CTS';
export const USART_SIGNAL_RTS = 'RTX';
export const USART_SIGNAL_CK = 'CK';
